import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import type { SecurityDepositTopUp } from "../../../../../types/bookings";
import axios from "../../../../../utils/axiosInceptor";
import type { BreakdownMode } from "../../../BookingForm/components/Commercial/add-plan/api/types";

type SaveCommercialRenewalBookingTerms = {
  durationType: string;
  numberOfRenewalTerms: number;
  securityDepositTopUp?: SecurityDepositTopUp;
};

type SaveCommercialRenewalLeaseTerms = {
  leaseStartDate: string;
  leaseEndDate: string;
  commencementDate: string;
};

export type SaveCommercialRenewalPayload = {
  torType: string;
  generate?: BreakdownMode;
  bookingTerms: SaveCommercialRenewalBookingTerms;
  leaseTerms: SaveCommercialRenewalLeaseTerms;
};

type SaveCommercialRenewalRequest = {
  leaseId: string;
  payload: SaveCommercialRenewalPayload;
};

export type SaveCommercialRenewalResult = {
  leaseId: string;
};

export type SaveCommercialRenewalResponse = ApiResponse<SaveCommercialRenewalResult>;

const saveCommercialRenewalRequest = async (request: SaveCommercialRenewalRequest) => {
  const { leaseId, payload } = request;
  const url = `${apiV1Endpoint}/booking/commercialRenewal/${leaseId}`;
  const response = await axios.post<SaveCommercialRenewalResponse>(url, payload);
  return response.data;
};

type UseSaveCommercialRenewalOptions = {
  onSuccess?: (data: SaveCommercialRenewalResponse) => void;
  onError?: (error: AxiosError<ApiResponse>) => void;
};

export const useSaveCommercialRenewal = (options: UseSaveCommercialRenewalOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: saveCommercialRenewalRequest,
    onSuccess,
    onError,
  });

  return {
    saveCommercialRenewalRequest: mutateAsync,
    isPendingSaveCommercialRenewalRequest: isPending,
  };
};
